import React from 'react';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Features from './components/Features';
import Benefits from './components/Benefits';
import Testimonial from './components/Testimonial';
import Industries from './components/Industries';
import CTA from './components/CTA';
import Footer from './components/Footer';
import './styles/index.css';

function App() {
  return (
    <div className="App">
      <Navigation />
      <Hero />
      <Features />
      <Benefits />
      <Testimonial />
      <Industries />
      <CTA />
      <Footer />
    </div>
  );
}

export default App;
